import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

export const usePricingUtils = () => {
  const { access } = useCurrentSession()

  const formatPrice = (amount: number, currencyCode: string) => {
    return new Intl.NumberFormat(access.locale, {
      style: 'currency',
      // TODO: use subscription currency
      currency: currencyCode,
      minimumFractionDigits: 2,
    }).format(amount / 100)
  }

  return { formatPrice }
}
